import cn from 'classnames'
import { ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations'

import styles from './Text.module.scss'

interface ITextProps {
  type: 'title' | 'h2'
  margin?: 'xs'
  text: string | ReactNode
}

export const Text = ({ text, type, margin }: ITextProps) => {
  const content = typeof text === 'string' ? <Translation span text={text} /> : text

  return <div className={cn(styles[type], { [styles[`margin-${margin}`]]: margin })}>{content}</div>
}
